import React, { useEffect, useState } from "react";
import { LuMaximize } from "react-icons/lu";
import { RxCross1 } from "react-icons/rx";
import { useParams } from "react-router-dom";
import { ApiCaller } from "../../config/api/api";
import defaultImage from "../../assets/images/2.png";
import VideoPlayer from "../videoPlayer/videoPlayer";

const SpecialDetail = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [galleryDataByType, setGalleryDataByType] = useState(null);
  const [hasImages, setHasImages] = useState(false);
  const [hasVideos, setHasVideos] = useState(false);

  const { types } = useParams();

  useEffect(() => {
    const fetchGalaryByType = async () => {
     try {
       const fetchData = await ApiCaller(`gallery/?gallery_type=${types}`,'GET');
 
       setGalleryDataByType(fetchData);
 
       if (fetchData && fetchData.results) {
         const imageExists = fetchData.results.some(
           (item) =>
             item.media_type && item.media_type.toLowerCase().includes("image")
         );
         const videoExists = fetchData.results.some(
           (item) =>
             item.media_type && item.media_type.toLowerCase().includes("video")
         );
 
         setHasImages(imageExists);
         setHasVideos(videoExists);
       }
     } catch (error) {
      
     }
    };

    fetchGalaryByType();
  }, [types]);
  // console.log("types in specialdetails", types);

  const imageItems =
    galleryDataByType?.results?.filter(
      (item) =>
        item.media_type && item.media_type.toLowerCase().includes("image")
    ) || [];

  const videoItems =
    galleryDataByType?.results?.filter(
      (item) =>
        item.media_type && item.media_type.toLowerCase().includes("video")
    ) || [];

  return (
    <section>
      <div className="py-14 relative px-5 sm:px-14 md:px-16 lg:px-20">
        <div>
          {hasImages && (
            <>
              <div className="text-2xl font-semibold text-center">
                OUR GALLERY IMAGE
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 my-3">
                {imageItems.length > 0 ? (
                  imageItems.map((MenuItem, id) => {
                    return (
                      <div
                        onClick={() => setFullScreenImage(MenuItem.file_url)}
                        className="text-white cursor-pointer group"
                      >
                        <div className="relative" key={id}>
                          <img
                            src={MenuItem.file_url || defaultImage}
                            alt="artistImage"
                            className="w-full h-96 object-cover"
                          />

                          <LuMaximize className="absolute left-1/2 top-[41%] transform scale-100 transition-transform duration-300 group-hover:scale-150 text-2xl font-bold" />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>Loading images...</div>
                )}
              </div>
            </>
          )}
          {fullScreenImage && (
            <div className="fixed inset-0 bg-black bg-opacity-1 flex justify-center items-center z-50">
              <div>
                <img
                  src={fullScreenImage}
                  alt="Fullscreen"
                  className="max-w-full max-h-screen object-contain"
                />

                <RxCross1
                  className="absolute top-2 left-3 text-white text-2xl cursor-pointer"
                  onClick={() => setFullScreenImage(null)}
                />
              </div>
            </div>
          )}
        </div>
        {hasVideos && (
          <div className="py-5">
            <div className="text-2xl font-semibold text-center">
              OUR GALLERY VIDEO
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 my-3">
              {videoItems.length > 0 ? (
                videoItems.map((videoItem, id) => (
                  <div key={id}>
                    <VideoPlayer src={videoItem.file_url} />
                  </div>
                ))
              ) : (
                <div>Loading videos...</div>
              )}
            </div>
          </div>
        )}
        {!galleryDataByType && (
          <div className="text-center">Loading gallery...</div>
        )}

        {galleryDataByType && !hasImages && !hasVideos && (
          <div className="text-center">No media found for this gallery.</div>
        )}
      </div>
    </section>
  );
};

export default SpecialDetail;
